{
  "de": {
    "imports": {
      "searchPlaceholder": "Name...",
      "selectedCount": "kein Element ausgewählt | {count} ausgewählt | {count} ausgewählt",
      "cancel": "Abbrechen",
      "confirm": "Auswählen",
      "discard": {
        "question": "Auswahl verwerfen?",
        "continue": "Weiter hinzufügen",
        "confirm": "Verwerfen"
      },
      "tabWithCount": "{label} ({count})",
      "tabMatches": "{label}: keine Treffer | {label}: {count} Treffer | {label}: {count} Treffer",
      "contentList": {
        "leaveFolder": "Zurück aus Ordner „{name}“",
        "openFolder": "Ordner „{name}“ öffnen",
        "loading": "Inhalte werden geladen",
        "noResults": {
          "title": "Hier gibt es keine Ergebnisse für „{query}“",
          "text": "Probiere einen anderen Suchbegriff"
        }
      },
      "loadMore": "Mehr laden",
      "submitFailed": "Import fehlgeschlagen. Bitte versuche es erneut.",
      "upload": {
        "addMore": "Weitere Dateien auswählen",
        "dropFiles": "Per Drag & Drop hier reinziehen oder Dateien auswählen.",
        "interrupted": "Ein Upload wurde abgebrochen. Bitte lade die Datei erneut hoch.",
        "removeFile": "„{name}“ entfernen",
        "uploaded": "Erfolgreich hochgeladen.",
        "wrongType": "Dieser Dateityp wird nicht unterstützt."
      },
      "toTeach": {
        "modalTitle": "to teach Arbeitsblätter importieren",
        "menuItem": "Import von to teach",
        "importedBadge": "Importiert von to teach",
        "link": {
          "title": "Konto verknüpfen",
          "body": "Dein Konto ist noch nicht mit to teach verknüpft. Verbinde dein Konto, um deine to teach Inhalte bei fobizz zu nutzen.",
          "confirm": "Zu to teach"
        },
        "worksheets": {
          "tabLabel": "Dein to teach Konto",
          "accountLink": "Dein to teach Konto",
          "searchPlaceholder": "to teach Arbeitsblätter durchsuchen",
          "emptyState": {
            "title": "Noch keine Inhalte bei to teach",
            "text": "Erstelle Inhalte auf to teach, um sie hier zu importieren."
          },
          "notLinked": {
            "title": "Noch nicht mit to teach verknüpft?",
            "text": "Erstelle ein Konto oder verbinde dein Konto, um to teach Inhalte bei fobizz zu nutzen.",
            "button": "zu to teach"
          },
          "errorLoading": "Deine to teach Arbeitsblätter konnten nicht geladen werden.",
          "batchQueuedFlash": "Dein Arbeitsblatt wird im Hintergrund importiert. | Dein Arbeitsblatt wird im Hintergrund importiert. | {count} Arbeitsblätter werden im Hintergrund importiert."
        }
      },
      "breadcrumb": {
        "label": "Ordnerpfad",
        "more": "Weitere Ordner anzeigen"
      },
      "myContent": {
        "empty": {
          "title": "Deine Ablage ist noch leer",
          "text": "Hochgeladene Dateien erscheinen hier."
        },
        "emptyFiltered": {
          "title": "Keine passenden Inhalte",
          "text": "Passe die Filter an oder wähle „Alle“."
        },
        "emptyFolder": "Dieser Ordner ist leer.",
        "errorLoading": "Deine Inhalte konnten nicht geladen werden.",
        "toggleFilters": "Filter anzeigen",
        "periodLabel": "Zeitraum:",
        "noAddableContent": {
          "title": "Hier gibt es nichts zum Hinzufügen",
          "text": "Diese Inhalte sind schon hinzugefügt oder lassen sich hier nicht verwenden."
        }
      }
    }
  }
}
